export const processViewData = {

  warehousePick: {
    entity: 'warehouseOrder',
    width: '480px',
    items: { array: 'lines', sortField: 'sortOrder', doneField: 'done',
      input: { qty: 'quantity', location: 'fromLocationId' } },
    progress: { completed: 'completedLines', total: 'totalLines' },
    sections: [
      {
        type: 'header',
        id: 'header',
        completedField: 'completed',
        completedLabel: 'warehouseOrder.pick.label.completed',
        progress: true,
        elements: [
          { type: 'field', value: 'number', scale: 'title' },
          { type: 'field', value: 'toLocationId', scale: 'normal', prefix: '→' }
        ],
        buttons: [
          {
            id: 'warehousePick.header.complete',
            label: 'warehouseOrder.pick.button.complete',
            variant: 'primary',
            effects: [
              { effect: 'setUi', id: 'openCompletion', target: 'completion', value: true }
            ]
          }
        ]
      },
      {
        type: 'selector',
        id: 'selector',
        default: 'toPick',
        options: [
          {
            id: 'toPick',
            label: 'warehouseOrder.pick.tab.toPick',
            filter: { field: 'done', value: false }
          },
          {
            id: 'picked',
            label: 'warehouseOrder.pick.tab.picked',
            filter: { field: 'done', value: true }
          }
        ]
      },
      {
        type: 'itemList',
        id: 'toPick',
        selector: 'toPick',
        itemCard: {
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'itemName', scale: 'title' },
                { type: 'field', value: 'itemSku', scale: 'normal' },
                { type: 'field', value: 'fromLocationId', scale: 'location', prefix: '📍' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'quantity', decorator: 'unitName' }
              ]
            }
          ]
        },
        buttons: [
          {
            id: 'warehousePick.toPick.pick',
            label: 'warehouseOrder.pick.button.pick',
            variant: 'primary',
            enabledWhen: { field: 'fromLocationId', operator: 'exists' },
            effects: [
              {
                effect: 'runOperation',
                id: 'pick',
                operation: 'pick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemList',
        id: 'picked',
        selector: 'picked',
        itemCard: {
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'itemName', scale: 'title' },
                { type: 'field', value: 'itemSku', scale: 'normal' },
                { type: 'field', value: 'fromLocationId', scale: 'location', prefix: '📍' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'actualQuantity', decorator: 'unitName' }
              ]
            }
          ]
        },
        buttons: [
          {
            id: 'warehousePick.picked.unpick',
            label: 'warehouseOrder.pick.button.unpick',
            variant: 'secondary',
            effects: [
              {
                effect: 'runOperation',
                id: 'unpick',
                operation: 'unpick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemDetail',
        id: 'itemDetail',
        doneLabel: 'warehouseOrder.pick.label.picked',
        uiDefault: null,
        query: {
          endpoint: 'inventoryLedger/agr/byItemLocation',
          endpointParam: 'itemId',
          paramValue: 'itemId',
          resultQtyField: 'ledgersum',
          resultLocationField: 'locationid'
        },
        blocks: [
          { type: 'title', id: 'title', value: 'itemName' },
          {
            type: 'body',
            id: 'body',
            columns: [
              {
                elements: [
                  { type: 'plugin', plugin: 'productImage', value: 'itemId' }
                ]
              },
              {
                elements: [
                  { type: 'field', value: 'itemSku', scale: 'label', label: 'warehouseOrder.processView.label.sku' },
                  {
                    type: 'quantitySplit',
                    planned: 'quantity',
                    actual: 'actualQuantity',
                    decorator: 'unitName',
                    plannedLabel: 'warehouseOrder.pick.label.qtyToPick',
                    actualLabel: 'warehouseOrder.pick.label.qtyPicked',
                    remainingLabel: 'warehouseOrder.pick.label.remaining'
                  }
                ]
              }
            ]
          },
          {
            type: 'plugin',
            plugin: 'inventoryStock',
            id: 'indicator',
            label: 'warehouseOrder.pick.label.stock',
            buttonLabel: 'warehouseOrder.pick.label.viewLocations',
            icon: '📦'
          },
          {
            type: 'plugin',
            plugin: 'inventoryLocationPicker',
            id: 'fromLocationId',
            displayField: 'fromLocationId',
            label: 'warehouseOrder.pick.label.pickFrom',
            modalTitle: 'warehouseOrder.form.line.fromLocation',
            icon: '📍',
            modalName: 'pickLocationModal',
            modalFormRef: 'selectFromLocationWarehouse'
          }
        ],
        buttons: [
          {
            id: 'warehousePick.itemDetail.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          },
          {
            id: 'warehousePick.itemDetail.pick',
            label: 'warehouseOrder.pick.button.pick',
            splitLabel: 'warehouseOrder.pick.button.splitAndPick',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'pick',
                operation: 'pick',
                splitOperation: 'splitAndPick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehousePick.itemDetail.removePick',
            label: 'warehouseOrder.pick.button.removePick',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'unpick',
                operation: 'unpick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              },
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          }
        ]
      },
      {
        type: 'completion',
        id: 'completion',
        uiDefault: false,
        blocks: [
          {
            type: 'title',
            id: 'title',
            label: 'warehouseOrder.pick.completion.title',
            subtitle: [
              { value: 'bookedNumber' },
              { value: 'toLocationId', prefix: '→' }
            ]
          },
          { type: 'progress', id: 'progress' },
          {
            type: 'lines',
            id: 'lines',
            columns: [
              {
                weight: 1,
                elements: [
                  { type: 'field', value: 'itemName', scale: 'label' }
                ]
              },
              {
                weight: 0,
                elements: [
                  { type: 'quantitySplit', planned: 'quantity', actual: 'actualQuantity', decorator: 'unitName' }
                ]
              }
            ]
          },
          { type: 'warning', id: 'warning', label: 'warehouseOrder.pick.completion.warning' }
        ],
        buttons: [
          {
            id: 'warehousePick.completion.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
            ]
          },
          {
            id: 'warehousePick.completion.finalizeOrder',
            label: 'warehouseOrder.pick.button.finalizeOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'complete',
                operation: 'complete',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehousePick.completion.splitIncompleteLines',
            label: 'warehouseOrder.pick.button.splitOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'split',
                operation: 'split',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ],
        closeEffects: [
          { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
        ]
      }
    ]
  },

  warehousePutaway: {
    entity: 'warehouseOrder',
    width: '480px',
    items: { array: 'lines', sortField: 'sortOrder', doneField: 'done',
      input: { qty: 'quantity', location: 'toLocationId' } },
    progress: { completed: 'completedLines', total: 'totalLines' },
    sections: [
      {
        type: 'header',
        id: 'header',
        completedField: 'completed',
        completedLabel: 'warehouseOrder.putaway.label.completed',
        progress: true,
        elements: [
          { type: 'field', value: 'number', scale: 'title' },
          { type: 'field', value: 'fromLocationId', scale: 'normal', suffix: '→' }
        ],
        buttons: [
          {
            id: 'warehousePutaway.header.complete',
            label: 'warehouseOrder.putaway.button.complete',
            variant: 'primary',
            effects: [
              { effect: 'setUi', id: 'openCompletion', target: 'completion', value: true }
            ]
          }
        ]
      },
      {
        type: 'selector',
        id: 'selector',
        default: 'toPutAway',
        options: [
          {
            id: 'toPutAway',
            label: 'warehouseOrder.putaway.tab.toPutAway',
            filter: { field: 'done', value: false }
          },
          {
            id: 'putAway',
            label: 'warehouseOrder.putaway.tab.putAway',
            filter: { field: 'done', value: true }
          }
        ]
      },
      {
        type: 'itemList',
        id: 'toPutAway',
        selector: 'toPutAway',
        itemCard: {
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'itemName', scale: 'title' },
                { type: 'field', value: 'itemSku', scale: 'normal' },
                { type: 'field', value: 'fromLocationId', scale: 'location', prefix: 'From:' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'quantity', decorator: 'unitName' }
              ]
            }
          ],
          locationPicker: {
            id: 'toLocationId',
            displayField: 'toLocationId',
            label: 'warehouseOrder.putaway.label.putTo',
            modalTitle: 'warehouseOrder.form.toLocation.modal.title',
            selectButtonKey: 'warehouseOrder.form.location.modal.select.button',
            valueMap: { toLocationId: 'id' },
            radioGroups: [
              {
                id: 'warehouse',
                title: 'warehouseOrder.form.location.modal.warehouse',
                entity: 'warehouse',
                valueField: 'code',
                idPrefix: 'W',
                labelField: 'code'
              },
              {
                id: 'hall',
                title: 'warehouseOrder.form.location.modal.hall',
                entity: 'warehouse/:id/hall',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'H'
              },
              {
                id: 'rack',
                title: 'warehouseOrder.form.location.modal.rack',
                entity: 'rack',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'R',
                columnCount: 6,
                filter: [
                  { param: 'warehouseCode', groupId: 'warehouse' },
                  { param: 'hallCode', groupId: 'hall' }
                ],
                subRadio: [
                  {
                    id: 'level',
                    idPrefix: 'L',
                    valueField: 'totalLevels',
                    title: 'warehouseOrder.form.location.modal.level',
                    columnCount: 6,
                    value: 'auto',
                    optional: true
                  },
                  {
                    id: 'position',
                    idPrefix: 'P',
                    valueField: 'totalPositions',
                    title: 'warehouseOrder.form.location.modal.position',
                    columnCount: 6,
                    value: 'auto'
                  }
                ]
              }
            ]
          }
        },
        buttons: [
          {
            id: 'warehousePutaway.toPutAway.putAway',
            label: 'warehouseOrder.putaway.button.putAway',
            variant: 'primary',
            enabledWhen: { field: 'fromLocationId', operator: 'exists' },
            effects: [
              {
                effect: 'runOperation',
                id: 'putaway',
                operation: 'putaway',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemList',
        id: 'putAway',
        selector: 'putAway',
        itemCard: {
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'itemName', scale: 'title' },
                { type: 'field', value: 'itemSku', scale: 'normal' },
                { type: 'field', value: 'toLocationId', scale: 'location', prefix: '📍' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'actualQuantity', decorator: 'unitName' }
              ]
            }
          ]
        },
        buttons: [
          {
            id: 'warehousePutaway.putAway.undo',
            label: 'warehouseOrder.putaway.button.unputAway',
            variant: 'secondary',
            effects: [
              {
                effect: 'runOperation',
                id: 'unputaway',
                operation: 'unputaway',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemDetail',
        id: 'itemDetail',
        doneLabel: 'warehouseOrder.putaway.label.putAway',
        uiDefault: null,
        query: {
          endpoint: 'inventoryLedger/agr/byItemLocation',
          endpointParam: 'itemId',
          paramValue: 'itemId',
          resultQtyField: 'ledgersum',
          resultLocationField: 'locationid'
        },
        blocks: [
          { type: 'title', id: 'title', value: 'itemName' },
          {
            type: 'body',
            id: 'body',
            columns: [
              {
                elements: [
                  { type: 'plugin', plugin: 'productImage', value: 'itemId' }
                ]
              },
              {
                elements: [
                  { type: 'field', value: 'itemSku', scale: 'label', label: 'warehouseOrder.processView.label.sku' },
                  {
                    type: 'quantitySplit',
                    planned: 'quantity',
                    actual: 'actualQuantity',
                    decorator: 'unitName',
                    plannedLabel: 'warehouseOrder.putaway.label.qtyToPutAway',
                    actualLabel: 'warehouseOrder.putaway.label.qtyPutAway',
                    remainingLabel: 'warehouseOrder.putaway.label.remaining'
                  }
                ]
              }
            ]
          },
          {
            type: 'plugin',
            plugin: 'inventoryStock',
            id: 'indicator',
            label: 'warehouseOrder.putaway.label.stock',
            buttonLabel: 'warehouseOrder.putaway.label.viewLocations',
            icon: '📦'
          },
          {
            type: 'plugin',
            plugin: 'inventoryLocationPicker',
            id: 'toLocationId',
            displayField: 'toLocationId',
            label: 'warehouseOrder.putaway.label.putTo',
            modalTitle: 'warehouseOrder.form.toLocation.modal.title',
            selectButtonKey: 'warehouseOrder.form.location.modal.select.button',
            valueMap: { toLocationId: 'id' },
            radioGroups: [
              {
                id: 'warehouse',
                title: 'warehouseOrder.form.location.modal.warehouse',
                entity: 'warehouse',
                valueField: 'code',
                idPrefix: 'W',
                labelField: 'code'
              },
              {
                id: 'hall',
                title: 'warehouseOrder.form.location.modal.hall',
                entity: 'warehouse/:id/hall',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'H'
              },
              {
                id: 'rack',
                title: 'warehouseOrder.form.location.modal.rack',
                entity: 'rack',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'R',
                columnCount: 6,
                filter: [
                  { param: 'warehouseCode', groupId: 'warehouse' },
                  { param: 'hallCode', groupId: 'hall' }
                ],
                subRadio: [
                  {
                    id: 'level',
                    idPrefix: 'L',
                    valueField: 'totalLevels',
                    title: 'warehouseOrder.form.location.modal.level',
                    columnCount: 6,
                    value: 'auto',
                    optional: true
                  },
                  {
                    id: 'position',
                    idPrefix: 'P',
                    valueField: 'totalPositions',
                    title: 'warehouseOrder.form.location.modal.position',
                    columnCount: 6,
                    value: 'auto'
                  }
                ]
              }
            ]
          }
        ],
        buttons: [
          {
            id: 'warehousePutaway.itemDetail.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          },
          {
            id: 'warehousePutaway.itemDetail.putAway',
            label: 'warehouseOrder.putaway.button.putAway',
            splitLabel: 'warehouseOrder.putaway.button.splitAndPutAway',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'putaway',
                operation: 'putaway',
                splitOperation: 'splitAndPutaway',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehousePutaway.itemDetail.undo',
            label: 'warehouseOrder.putaway.button.unputAway',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'unputaway',
                operation: 'unputaway',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              },
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          }
        ]
      },
      {
        type: 'completion',
        id: 'completion',
        uiDefault: false,
        blocks: [
          {
            type: 'title',
            id: 'title',
            label: 'warehouseOrder.putaway.completion.title',
            subtitle: [
              { value: 'bookedNumber' },
              { value: 'fromLocationId', prefix: '←' }
            ]
          },
          { type: 'progress', id: 'progress' },
          {
            type: 'lines',
            id: 'lines',
            columns: [
              {
                weight: 1,
                elements: [
                  { type: 'field', value: 'itemName', scale: 'label' }
                ]
              },
              {
                weight: 0,
                elements: [
                  { type: 'quantitySplit', planned: 'quantity', actual: 'actualQuantity', decorator: 'unitName' }
                ]
              }
            ]
          },
          { type: 'warning', id: 'warning', label: 'warehouseOrder.putaway.completion.warning' }
        ],
        buttons: [
          {
            id: 'warehousePutaway.completion.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
            ]
          },
          {
            id: 'warehousePutaway.completion.finalizeOrder',
            label: 'warehouseOrder.putaway.button.finalizeOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'complete',
                operation: 'complete',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehousePutaway.completion.splitIncompleteLines',
            label: 'warehouseOrder.putaway.button.splitOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'split',
                operation: 'split',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ],
        closeEffects: [
          { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
        ]
      }
    ]
  },

  warehouseQuarantine: {
    entity: 'warehouseOrder',
    width: '480px',
    items: { array: 'lines', sortField: 'sortOrder', doneField: 'done',
      input: { qty: 'quantity', location: 'fromLocationId' } },
    progress: { completed: 'completedLines', total: 'totalLines' },
    sections: [
      {
        type: 'header',
        id: 'header',
        completedField: 'completed',
        completedLabel: 'warehouseOrder.quarantine.label.completed',
        progress: true,
        elements: [
          { type: 'field', value: 'number', scale: 'title' },
          { type: 'field', value: 'fromLocationId', scale: 'normal' },
          { type: 'field', value: 'toLocationId', scale: 'normal', prefix: '→' }
        ],
        buttons: [
          {
            id: 'warehouseQuarantine.header.complete',
            label: 'warehouseOrder.quarantine.button.complete',
            variant: 'primary',
            effects: [
              { effect: 'setUi', id: 'openCompletion', target: 'completion', value: true }
            ]
          }
        ]
      },
      {
        type: 'selector',
        id: 'selector',
        default: 'toQuarantine',
        options: [
          {
            id: 'toQuarantine',
            label: 'warehouseOrder.quarantine.tab.toQuarantine',
            filter: { field: 'done', value: false }
          },
          {
            id: 'quarantined',
            label: 'warehouseOrder.quarantine.tab.quarantined',
            filter: { field: 'done', value: true }
          }
        ]
      },
      {
        type: 'itemList',
        id: 'toQuarantine',
        selector: 'toQuarantine',
        itemCard: {
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'itemName', scale: 'title' },
                { type: 'field', value: 'itemSku', scale: 'normal' },
                { type: 'field', value: 'toLocationId', scale: 'location', prefix: 'To:' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'quantity', decorator: 'unitName' }
              ]
            }
          ],
          locationPicker: {
            id: 'fromLocationId',
            displayField: 'fromLocationId',
            label: 'warehouseOrder.quarantine.label.pickFrom',
            modalTitle: 'warehouseOrder.form.line.fromLocation.modal.title',
            selectButtonKey: 'warehouseOrder.form.location.modal.select.button',
            valueMap: { fromLocationId: 'id' },
            radioGroups: [
              {
                id: 'warehouse',
                title: 'warehouseOrder.form.location.modal.warehouse',
                entity: 'warehouse',
                valueField: 'code',
                idPrefix: 'W',
                labelField: 'code'
              },
              {
                id: 'hall',
                title: 'warehouseOrder.form.location.modal.hall',
                entity: 'warehouse/:id/hall',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'H'
              },
              {
                id: 'rack',
                title: 'warehouseOrder.form.location.modal.rack',
                entity: 'rack',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'R',
                columnCount: 6,
                filter: [
                  { param: 'warehouseCode', groupId: 'warehouse' },
                  { param: 'hallCode', groupId: 'hall' }
                ],
                subRadio: [
                  {
                    id: 'level',
                    idPrefix: 'L',
                    valueField: 'totalLevels',
                    title: 'warehouseOrder.form.location.modal.level',
                    columnCount: 6,
                    value: 'auto',
                    optional: true
                  },
                  {
                    id: 'position',
                    idPrefix: 'P',
                    valueField: 'totalPositions',
                    title: 'warehouseOrder.form.location.modal.position',
                    columnCount: 6,
                    value: 'auto'
                  }
                ]
              }
            ]
          }
        },
        buttons: [
          {
            id: 'warehouseQuarantine.toQuarantine.pick',
            label: 'warehouseOrder.quarantine.button.pick',
            variant: 'primary',
            enabledWhen: { field: 'toLocationId', operator: 'exists' },
            effects: [
              {
                effect: 'runOperation',
                id: 'pick',
                operation: 'pick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemList',
        id: 'quarantined',
        selector: 'quarantined',
        itemCard: {
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'itemName', scale: 'title' },
                { type: 'field', value: 'itemSku', scale: 'normal' },
                { type: 'field', value: 'fromLocationId', scale: 'location', prefix: 'From:' },
                { type: 'field', value: 'toLocationId', scale: 'location', prefix: 'To:' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'actualQuantity', decorator: 'unitName' }
              ]
            }
          ]
        },
        buttons: [
          {
            id: 'warehouseQuarantine.quarantined.undo',
            label: 'warehouseOrder.quarantine.button.undo',
            variant: 'secondary',
            effects: [
              {
                effect: 'runOperation',
                id: 'unpick',
                operation: 'unpick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemDetail',
        id: 'itemDetail',
        doneLabel: 'warehouseOrder.quarantine.label.quarantined',
        uiDefault: null,
        query: {
          endpoint: 'inventoryLedger/agr/byItemLocation',
          endpointParam: 'itemId',
          paramValue: 'itemId',
          resultQtyField: 'ledgersum',
          resultLocationField: 'locationid'
        },
        blocks: [
          { type: 'title', id: 'title', value: 'itemName' },
          {
            type: 'body',
            id: 'body',
            columns: [
              {
                elements: [
                  { type: 'plugin', plugin: 'productImage', value: 'itemId' }
                ]
              },
              {
                elements: [
                  { type: 'field', value: 'itemSku', scale: 'label', label: 'warehouseOrder.processView.label.sku' },
                  {
                    type: 'quantitySplit',
                    planned: 'quantity',
                    actual: 'actualQuantity',
                    decorator: 'unitName',
                    plannedLabel: 'warehouseOrder.quarantine.label.qtyToMove',
                    actualLabel: 'warehouseOrder.quarantine.label.qtyMoved',
                    remainingLabel: 'warehouseOrder.quarantine.label.remaining'
                  }
                ]
              }
            ]
          },
          {
            type: 'plugin',
            plugin: 'inventoryStock',
            id: 'indicator',
            label: 'warehouseOrder.quarantine.label.stock',
            buttonLabel: 'warehouseOrder.quarantine.label.viewLocations',
            icon: '📦'
          },
          {
            type: 'plugin',
            plugin: 'inventoryLocationPicker',
            id: 'fromLocationId',
            displayField: 'fromLocationId',
            label: 'warehouseOrder.quarantine.label.pickFrom',
            modalTitle: 'warehouseOrder.form.line.fromLocation',
            icon: '📍',
            modalName: 'quarantineLocationModal',
            modalFormRef: 'selectFromLocationWarehouse'
          }
        ],
        buttons: [
          {
            id: 'warehouseQuarantine.itemDetail.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          },
          {
            id: 'warehouseQuarantine.itemDetail.pick',
            label: 'warehouseOrder.quarantine.button.pick',
            splitLabel: 'warehouseOrder.quarantine.button.splitAndPick',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'pick',
                operation: 'pick',
                splitOperation: 'splitAndPick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehouseQuarantine.itemDetail.undo',
            label: 'warehouseOrder.quarantine.button.undo',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'unpick',
                operation: 'unpick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              },
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          }
        ]
      },
      {
        type: 'completion',
        id: 'completion',
        uiDefault: false,
        blocks: [
          {
            type: 'title',
            id: 'title',
            label: 'warehouseOrder.quarantine.completion.title',
            subtitle: [
              { value: 'bookedNumber' },
              { value: 'fromLocationId' },
              { value: 'toLocationId', prefix: '→' }
            ]
          },
          { type: 'progress', id: 'progress' },
          {
            type: 'lines',
            id: 'lines',
            columns: [
              {
                weight: 1,
                elements: [
                  { type: 'field', value: 'itemName', scale: 'label' }
                ]
              },
              {
                weight: 0,
                elements: [
                  { type: 'quantitySplit', planned: 'quantity', actual: 'actualQuantity', decorator: 'unitName' }
                ]
              }
            ]
          },
          { type: 'warning', id: 'warning', label: 'warehouseOrder.quarantine.completion.warning' }
        ],
        buttons: [
          {
            id: 'warehouseQuarantine.completion.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
            ]
          },
          {
            id: 'warehouseQuarantine.completion.finalizeOrder',
            label: 'warehouseOrder.quarantine.button.finalizeOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'complete',
                operation: 'complete',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehouseQuarantine.completion.splitIncompleteLines',
            label: 'warehouseOrder.quarantine.button.splitOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'split',
                operation: 'split',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ],
        closeEffects: [
          { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
        ]
      }
    ]
  },

  warehouseReturn: {
    entity: 'warehouseOrder',
    width: '480px',
    items: { array: 'lines', sortField: 'sortOrder', doneField: 'done',
      input: { qty: 'quantity', location: 'toLocationId' } },
    progress: { completed: 'completedLines', total: 'totalLines' },
    sections: [
      {
        type: 'header',
        id: 'header',
        completedField: 'completed',
        completedLabel: 'warehouseOrder.return.label.completed',
        progress: true,
        elements: [
          { type: 'field', value: 'number', scale: 'title' },
          { type: 'field', value: 'fromLocationId', scale: 'normal', suffix: '→' }
        ],
        buttons: [
          {
            id: 'warehouseReturn.header.complete',
            label: 'warehouseOrder.return.button.complete',
            variant: 'primary',
            effects: [
              { effect: 'setUi', id: 'openCompletion', target: 'completion', value: true }
            ]
          }
        ]
      },
      {
        type: 'selector',
        id: 'selector',
        default: 'toReturn',
        options: [
          {
            id: 'toReturn',
            label: 'warehouseOrder.return.tab.toReturn',
            filter: { field: 'done', value: false }
          },
          {
            id: 'returned',
            label: 'warehouseOrder.return.tab.returned',
            filter: { field: 'done', value: true }
          }
        ]
      },
      {
        type: 'itemList',
        id: 'toReturn',
        selector: 'toReturn',
        itemCard: {
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'itemName', scale: 'title' },
                { type: 'field', value: 'itemSku', scale: 'normal' },
                { type: 'field', value: 'fromLocationId', scale: 'location', prefix: 'From:' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'quantity', decorator: 'unitName' }
              ]
            }
          ],
          locationPicker: {
            id: 'toLocationId',
            displayField: 'toLocationId',
            label: 'warehouseOrder.return.label.putTo',
            modalTitle: 'warehouseOrder.form.toLocation.modal.title',
            selectButtonKey: 'warehouseOrder.form.location.modal.select.button',
            valueMap: { toLocationId: 'id' },
            radioGroups: [
              {
                id: 'warehouse',
                title: 'warehouseOrder.form.location.modal.warehouse',
                entity: 'warehouse',
                valueField: 'code',
                idPrefix: 'W',
                labelField: 'code'
              },
              {
                id: 'hall',
                title: 'warehouseOrder.form.location.modal.hall',
                entity: 'warehouse/:id/hall',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'H'
              },
              {
                id: 'rack',
                title: 'warehouseOrder.form.location.modal.rack',
                entity: 'rack',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'R',
                columnCount: 6,
                filter: [
                  { param: 'warehouseCode', groupId: 'warehouse' },
                  { param: 'hallCode', groupId: 'hall' }
                ],
                subRadio: [
                  {
                    id: 'level',
                    idPrefix: 'L',
                    valueField: 'totalLevels',
                    title: 'warehouseOrder.form.location.modal.level',
                    columnCount: 6,
                    value: 'auto',
                    optional: true
                  },
                  {
                    id: 'position',
                    idPrefix: 'P',
                    valueField: 'totalPositions',
                    title: 'warehouseOrder.form.location.modal.position',
                    columnCount: 6,
                    value: 'auto'
                  }
                ]
              }
            ]
          }
        },
        buttons: [
          {
            id: 'warehouseReturn.toReturn.putAway',
            label: 'warehouseOrder.return.button.putAway',
            variant: 'primary',
            enabledWhen: { field: 'fromLocationId', operator: 'exists' },
            effects: [
              {
                effect: 'runOperation',
                id: 'putaway',
                operation: 'putaway',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemList',
        id: 'returned',
        selector: 'returned',
        itemCard: {
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'itemName', scale: 'title' },
                { type: 'field', value: 'itemSku', scale: 'normal' },
                { type: 'field', value: 'toLocationId', scale: 'location', prefix: '📍' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'actualQuantity', decorator: 'unitName' }
              ]
            }
          ]
        },
        buttons: [
          {
            id: 'warehouseReturn.returned.undo',
            label: 'warehouseOrder.return.button.undo',
            variant: 'secondary',
            effects: [
              {
                effect: 'runOperation',
                id: 'unputaway',
                operation: 'unputaway',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemDetail',
        id: 'itemDetail',
        doneLabel: 'warehouseOrder.return.label.returned',
        uiDefault: null,
        query: {
          endpoint: 'inventoryLedger/agr/byItemLocation',
          endpointParam: 'itemId',
          paramValue: 'itemId',
          resultQtyField: 'ledgersum',
          resultLocationField: 'locationid'
        },
        blocks: [
          { type: 'title', id: 'title', value: 'itemName' },
          {
            type: 'body',
            id: 'body',
            columns: [
              {
                elements: [
                  { type: 'plugin', plugin: 'productImage', value: 'itemId' }
                ]
              },
              {
                elements: [
                  { type: 'field', value: 'itemSku', scale: 'label', label: 'warehouseOrder.processView.label.sku' },
                  {
                    type: 'quantitySplit',
                    planned: 'quantity',
                    actual: 'actualQuantity',
                    decorator: 'unitName',
                    plannedLabel: 'warehouseOrder.return.label.qtyToReturn',
                    actualLabel: 'warehouseOrder.return.label.qtyReturned',
                    remainingLabel: 'warehouseOrder.return.label.remaining'
                  }
                ]
              }
            ]
          },
          {
            type: 'plugin',
            plugin: 'inventoryStock',
            id: 'indicator',
            label: 'warehouseOrder.return.label.stock',
            buttonLabel: 'warehouseOrder.return.label.viewLocations',
            icon: '📦'
          },
          {
            type: 'plugin',
            plugin: 'inventoryLocationPicker',
            id: 'toLocationId',
            displayField: 'toLocationId',
            label: 'warehouseOrder.return.label.putTo',
            modalTitle: 'warehouseOrder.form.toLocation.modal.title',
            selectButtonKey: 'warehouseOrder.form.location.modal.select.button',
            valueMap: { toLocationId: 'id' },
            radioGroups: [
              {
                id: 'warehouse',
                title: 'warehouseOrder.form.location.modal.warehouse',
                entity: 'warehouse',
                valueField: 'code',
                idPrefix: 'W',
                labelField: 'code'
              },
              {
                id: 'hall',
                title: 'warehouseOrder.form.location.modal.hall',
                entity: 'warehouse/:id/hall',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'H'
              },
              {
                id: 'rack',
                title: 'warehouseOrder.form.location.modal.rack',
                entity: 'rack',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'R',
                columnCount: 6,
                filter: [
                  { param: 'warehouseCode', groupId: 'warehouse' },
                  { param: 'hallCode', groupId: 'hall' }
                ],
                subRadio: [
                  {
                    id: 'level',
                    idPrefix: 'L',
                    valueField: 'totalLevels',
                    title: 'warehouseOrder.form.location.modal.level',
                    columnCount: 6,
                    value: 'auto',
                    optional: true
                  },
                  {
                    id: 'position',
                    idPrefix: 'P',
                    valueField: 'totalPositions',
                    title: 'warehouseOrder.form.location.modal.position',
                    columnCount: 6,
                    value: 'auto'
                  }
                ]
              }
            ]
          }
        ],
        buttons: [
          {
            id: 'warehouseReturn.itemDetail.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          },
          {
            id: 'warehouseReturn.itemDetail.putAway',
            label: 'warehouseOrder.return.button.putAway',
            splitLabel: 'warehouseOrder.return.button.splitAndPutAway',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'putaway',
                operation: 'putaway',
                splitOperation: 'splitAndPutaway',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehouseReturn.itemDetail.undo',
            label: 'warehouseOrder.return.button.undo',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'unputaway',
                operation: 'unputaway',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              },
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          }
        ]
      },
      {
        type: 'completion',
        id: 'completion',
        uiDefault: false,
        blocks: [
          {
            type: 'title',
            id: 'title',
            label: 'warehouseOrder.return.completion.title',
            subtitle: [
              { value: 'bookedNumber' },
              { value: 'fromLocationId', prefix: '←' }
            ]
          },
          { type: 'progress', id: 'progress' },
          {
            type: 'lines',
            id: 'lines',
            columns: [
              {
                weight: 1,
                elements: [
                  { type: 'field', value: 'itemName', scale: 'label' }
                ]
              },
              {
                weight: 0,
                elements: [
                  { type: 'quantitySplit', planned: 'quantity', actual: 'actualQuantity', decorator: 'unitName' }
                ]
              }
            ]
          },
          { type: 'warning', id: 'warning', label: 'warehouseOrder.return.completion.warning' }
        ],
        buttons: [
          {
            id: 'warehouseReturn.completion.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
            ]
          },
          {
            id: 'warehouseReturn.completion.finalizeOrder',
            label: 'warehouseOrder.return.button.finalizeOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'complete',
                operation: 'complete',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehouseReturn.completion.splitIncompleteLines',
            label: 'warehouseOrder.return.button.splitOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'split',
                operation: 'split',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ],
        closeEffects: [
          { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
        ]
      }
    ]
  },

  warehouseTransfer: {
    entity: 'warehouseOrder',
    width: '480px',
    items: { array: 'lines', sortField: 'sortOrder', doneField: 'done',
      input: { qty: 'quantity', location: 'fromLocationId' } },
    progress: { completed: 'completedLines', total: 'totalLines' },
    groups: {
      by: 'toLocationId',
      include: { field: 'done', value: true },
      quantity: ['actualQuantity', 'quantity'],
      labelField: 'itemName',
      doneField: 'dropped',
      sequence: { from: 'routeStops', include: { field: 'action', value: 'drop' }, key: 'locationId', order: 'seq' },
      tag: { from: 'routeStops', exclude: { field: 'action', value: 'travel' }, key: 'locationId', value: 'warehouseCode', matchFields: ['fromLocationId', 'toLocationId'] }
    },
    sections: [
      {
        type: 'header',
        id: 'header',
        completedField: 'completed',
        completedLabel: 'warehouseOrder.transfer.label.completed',
        progress: true,
        completeRequires: { field: 'dropped', value: true, hint: 'warehouseOrder.transfer.completeRequires.hint' },
        elements: [
          { type: 'field', value: 'number', scale: 'title' },
          { type: 'field', value: 'fromLocationId', scale: 'normal' },
          { type: 'field', value: 'toLocationId', scale: 'normal', prefix: '→' }
        ],
        buttons: [
          {
            id: 'warehouseTransfer.header.complete',
            label: 'warehouseOrder.transfer.button.complete',
            variant: 'primary',
            effects: [
              { effect: 'setUi', id: 'openCompletion', target: 'completion', value: true }
            ]
          }
        ]
      },
      {
        type: 'selector',
        id: 'selector',
        default: 'toPick',
        options: [
          {
            id: 'toPick',
            label: 'warehouseOrder.transfer.tab.toPick',
            sortField: 'sortOrder',
            filter: { field: 'done', value: false }
          },
          { id: 'toDrop', label: 'warehouseOrder.transfer.tab.toDrop', source: 'groups', groupFilter: { field: 'allDone', value: false } },
          { id: 'dropped', label: 'warehouseOrder.transfer.tab.dropped', source: 'groups', groupFilter: { field: 'allDone', value: true } }
        ]
      },
      {
        type: 'itemList',
        id: 'toPick',
        selector: 'toPick',
        itemCard: {
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'itemName', scale: 'title' },
                { type: 'field', value: 'itemSku', scale: 'normal' },
                { type: 'field', value: 'toLocationId', scale: 'location', prefix: 'To:' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'quantity', decorator: 'unitName' }
              ]
            }
          ],
          locationPicker: {
            id: 'fromLocationId',
            displayField: 'fromLocationId',
            label: 'warehouseOrder.transfer.label.pickFrom',
            modalTitle: 'warehouseOrder.form.line.fromLocation.modal.title',
            selectButtonKey: 'warehouseOrder.form.location.modal.select.button',
            valueMap: { fromLocationId: 'id' },
            radioGroups: [
              {
                id: 'warehouse',
                title: 'warehouseOrder.form.location.modal.warehouse',
                entity: 'warehouse',
                valueField: 'code',
                idPrefix: 'W',
                labelField: 'code'
              },
              {
                id: 'hall',
                title: 'warehouseOrder.form.location.modal.hall',
                entity: 'warehouse/:id/hall',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'H'
              },
              {
                id: 'rack',
                title: 'warehouseOrder.form.location.modal.rack',
                entity: 'rack',
                dependsOn: 'warehouse',
                valueField: 'code',
                labelField: 'code',
                idPrefix: 'R',
                columnCount: 6,
                filter: [
                  { param: 'warehouseCode', groupId: 'warehouse' },
                  { param: 'hallCode', groupId: 'hall' }
                ],
                subRadio: [
                  {
                    id: 'level',
                    idPrefix: 'L',
                    valueField: 'totalLevels',
                    title: 'warehouseOrder.form.location.modal.level',
                    columnCount: 6,
                    value: 'auto',
                    optional: true
                  },
                  {
                    id: 'position',
                    idPrefix: 'P',
                    valueField: 'totalPositions',
                    title: 'warehouseOrder.form.location.modal.position',
                    columnCount: 6,
                    value: 'auto'
                  }
                ]
              }
            ]
          }
        },
        buttons: [
          {
            id: 'warehouseTransfer.toPick.pick',
            label: 'warehouseOrder.transfer.button.pick',
            variant: 'primary',
            enabledWhen: { field: 'toLocationId', operator: 'exists' },
            effects: [
              {
                effect: 'runOperation',
                id: 'pick',
                operation: 'pick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemList',
        id: 'toDrop',
        selector: 'toDrop',
        itemCard: {
          showDetail: false,
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'toLocationId', scale: 'location', prefix: 'To:' },
                { type: 'field', value: 'summary', scale: 'title' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'quantity' }
              ]
            }
          ]
        },
        buttons: [
          {
            id: 'warehouseTransfer.toDrop.drop',
            label: 'warehouseOrder.transfer.button.drop',
            variant: 'primary',
            effects: [
              { effect: 'runOperation', id: 'dropLocation', operation: 'dropLocation' }
            ]
          },
          {
            id: 'warehouseTransfer.toDrop.unpickAll',
            label: 'warehouseOrder.transfer.button.unpickAll',
            variant: 'secondary',
            effects: [
              {
                effect: 'runOperation',
                id: 'unpickLocation',
                operation: 'unpickLocation',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'itemList',
        id: 'dropped',
        selector: 'dropped',
        itemCard: {
          showDetail: false,
          columns: [
            {
              weight: 1,
              elements: [
                { type: 'field', value: 'toLocationId', scale: 'location', prefix: 'To:' },
                { type: 'field', value: 'summary', scale: 'title' }
              ]
            },
            {
              weight: 0,
              elements: [
                { type: 'quantity', value: 'quantity' }
              ]
            }
          ]
        },
        buttons: [
          {
            id: 'warehouseTransfer.dropped.undrop',
            label: 'warehouseOrder.transfer.button.undrop',
            variant: 'secondary',
            effects: [
              { effect: 'runOperation', id: 'undropLocation', operation: 'undropLocation' }
            ]
          }
        ]
      },
      {
        type: 'itemDetail',
        id: 'itemDetail',
        doneLabel: 'warehouseOrder.transfer.label.picked',
        uiDefault: null,
        query: {
          endpoint: 'inventoryLedger/agr/byItemLocation',
          endpointParam: 'itemId',
          paramValue: 'itemId',
          resultQtyField: 'ledgersum',
          resultLocationField: 'locationid'
        },
        blocks: [
          { type: 'title', id: 'title', value: 'itemName' },
          {
            type: 'body',
            id: 'body',
            columns: [
              {
                elements: [
                  { type: 'plugin', plugin: 'productImage', value: 'itemId' }
                ]
              },
              {
                elements: [
                  { type: 'field', value: 'itemSku', scale: 'label', label: 'warehouseOrder.processView.label.sku' },
                  {
                    type: 'quantitySplit',
                    planned: 'quantity',
                    actual: 'actualQuantity',
                    decorator: 'unitName',
                    plannedLabel: 'warehouseOrder.transfer.label.qtyToPick',
                    actualLabel: 'warehouseOrder.transfer.label.qtyPicked',
                    remainingLabel: 'warehouseOrder.transfer.label.remaining'
                  }
                ]
              }
            ]
          },
          {
            type: 'plugin',
            plugin: 'inventoryStock',
            id: 'indicator',
            label: 'warehouseOrder.transfer.label.stock',
            buttonLabel: 'warehouseOrder.transfer.label.viewLocations',
            icon: '📦'
          },
          {
            type: 'plugin',
            plugin: 'inventoryLocationPicker',
            id: 'fromLocationId',
            displayField: 'fromLocationId',
            label: 'warehouseOrder.transfer.label.pickFrom',
            modalTitle: 'warehouseOrder.form.line.fromLocation',
            icon: '📍',
            modalName: 'transferLocationModal',
            modalFormRef: 'selectFromLocationWarehouse'
          }
        ],
        buttons: [
          {
            id: 'warehouseTransfer.itemDetail.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          },
          {
            id: 'warehouseTransfer.itemDetail.pick',
            label: 'warehouseOrder.transfer.button.pick',
            splitLabel: 'warehouseOrder.transfer.button.splitAndPick',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'pick',
                operation: 'pick',
                splitOperation: 'splitAndPick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehouseTransfer.itemDetail.removePick',
            label: 'warehouseOrder.transfer.button.removePick',
            variant: 'primary',
            position: 'right',
            condition: { field: '$done', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'unpick',
                operation: 'unpick',
                invalidate: [
                  'product/:itemId/itemLocation'
                ]
              },
              { effect: 'setUi', id: 'closeItemDetail', target: 'itemDetail', value: null }
            ]
          }
        ]
      },
      {
        type: 'completion',
        id: 'completion',
        uiDefault: false,
        blocks: [
          {
            type: 'title',
            id: 'title',
            label: 'warehouseOrder.transfer.completion.title',
            subtitle: [
              { value: 'bookedNumber' },
              { value: 'fromLocationId' },
              { value: 'toLocationId', prefix: '→' }
            ]
          },
          { type: 'progress', id: 'progress' },
          {
            type: 'lines',
            id: 'lines',
            columns: [
              {
                weight: 1,
                elements: [
                  { type: 'field', value: 'itemName', scale: 'label' }
                ]
              },
              {
                weight: 0,
                elements: [
                  { type: 'quantitySplit', planned: 'quantity', actual: 'actualQuantity', decorator: 'unitName' }
                ]
              }
            ]
          },
          { type: 'warning', id: 'warning', label: 'warehouseOrder.transfer.completion.warning' }
        ],
        buttons: [
          {
            id: 'warehouseTransfer.completion.cancel',
            label: 'all.confirm.cancel',
            variant: 'secondary',
            position: 'left',
            effects: [
              { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
            ]
          },
          {
            id: 'warehouseTransfer.completion.finalizeOrder',
            label: 'warehouseOrder.transfer.button.finalizeOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: true },
            effects: [
              {
                effect: 'runOperation',
                id: 'complete',
                operation: 'complete',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          },
          {
            id: 'warehouseTransfer.completion.splitIncompleteLines',
            label: 'warehouseOrder.transfer.button.splitOrder',
            variant: 'primary',
            position: 'right',
            condition: { field: '$allDone', operator: 'equals', value: false },
            effects: [
              {
                effect: 'runOperation',
                id: 'split',
                operation: 'split',
                reload: true,
                invalidate: [
                  'warehouseOrder',
                  'product/:itemId/itemLocation'
                ]
              }
            ]
          }
        ],
        closeEffects: [
          { effect: 'setUi', id: 'closeCompletion', target: 'completion', value: false }
        ]
      }
    ]
  },

}
